// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.py-10[data-v-4c85f1d8] {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.card[data-v-4c85f1d8] {
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}
.card[data-v-4c85f1d8]:hover {
  transform: translateY(-5px);
  box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
}
.link[data-v-4c85f1d8] {
  color: var(--bs-primary);
  text-decoration: none;
  font-weight: 500;
}
.link[data-v-4c85f1d8]:hover {
  color: var(--bs-primary-dark);
  text-decoration: underline;
}
.link-sm[data-v-4c85f1d8] {
  font-size: 0.875rem;
}

/* Loading overlay animation */
.position-absolute[data-v-4c85f1d8] {
  border-radius: 0.5rem;
}

/* Featured image styling */
.featured-image[data-v-4c85f1d8] {
  border-radius: 0.5rem 0.5rem 0 0;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.card:hover .featured-image[data-v-4c85f1d8] {
  transform: scale(1.02);
  box-shadow: 0 8px 20px rgba(0,0,0,0.15);
}

/* Add subtle border to images */
.card-img-top[data-v-4c85f1d8] {
  border-bottom: 1px solid rgba(0,0,0,0.08);
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
